var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoutDark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 10.154,
    viewBox: "0 0 12 10.154",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "log-out-outline",
    transform: "translate(-3.375 -5.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1505",
    "data-name": "Path 1505",
    d: "M9.606,15.779H4.991a1.617,1.617,0,0,1-1.616-1.616V7.241A1.617,1.617,0,0,1,4.991,5.625H9.375a1.818,1.818,0,0,1,1.846,1.616V8.395a.462.462,0,0,1-.923,0V7.241c0-.33-.483-.693-.923-.693H4.991a.693.693,0,0,0-.693.693v6.923a.693.693,0,0,0,.693.693H9.606a.693.693,0,0,0,.693-.693V13.01a.462.462,0,1,1,.923,0v1.154A1.617,1.617,0,0,1,9.606,15.779Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_10",
    "data-name": "Union 10",
    d: "M-2692.952-9854.971a.462.462,0,0,1,0-.653l1.519-1.52h-6.731a.462.462,0,0,1-.46-.463.46.46,0,0,1,.46-.461h6.733l-1.521-1.519a.462.462,0,0,1,0-.653.462.462,0,0,1,.653,0l2.309,2.309a.462.462,0,0,1,0,.65l-2.309,2.31a.461.461,0,0,1-.327.133A.465.465,0,0,1-2692.952-9854.971Z",
    transform: "translate(2705.231 9868.308)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoutDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LogoutDark.d5dd064d27d53ca6c4bd61e06f92c9ef.svg";